import { Component, Input } from "@angular/core";
import { Alert, AlertType } from "../models/Alerts.model";

@Component({
    selector: "casing-plan-alert",
    templateUrl: "./casing-plan-alert.component.html",
    styleUrls: ["./casing-plan-alert.component.scss"],
    standalone: false
})
export class CasingPlanAlertComponent {

    @Input() alert: Alert;

    alertTypes = AlertType;

    constructor() { }   

}
